import { FC, ReactNode } from 'react'
import { useLocation, Outlet } from 'react-router-dom'
import { Box, useTheme, CircularProgress } from '@mui/material'

import Sidebar from './Sidebar'
import Header from './Header'
import { AppAlerts, MessageNavigationDialogHost, TrialExpiredDialogHost } from '../../components'
import CommandPalette from '../../components/CommandPalette'
import { useAppSelector, useCommandPalette } from '../../hooks'
import { CommandPaletteProvider } from '../../contexts/CommandPaletteContext'
import { FeatureAnnouncementProvider } from '../../contexts/FeatureAnnouncementContext'
import SubscriptionPopup from '../../content/applications/Users/subscription-plan/SubscriptionPopup'
import { searchProperty } from '../../utils'
import PaymentDuePopup from '../../content/applications/PendingBills/PaymentDuePopup'

interface SidebarLayoutProps {
  children?: ReactNode
}

const SidebarLayout: FC<SidebarLayoutProps> = () => {
  const theme = useTheme()
  const location = useLocation()
  const commandPalette = useCommandPalette()
  const userData = useAppSelector((state) => state.userData)

  console.log({ location })
  const loading = useAppSelector((state) => searchProperty(state, 'loading'))
  return (
    <CommandPaletteProvider>
      <FeatureAnnouncementProvider>
        <SubscriptionPopup />
        <PaymentDuePopup />
        <TrialExpiredDialogHost />
        <MessageNavigationDialogHost />
        <Header />
        <Sidebar />
        <CommandPalette
          open={commandPalette.isOpen}
          onClose={commandPalette.close}
          userData={userData.data}
        />
        {loading && !process.env.OFFLINE && (
          <Box
            sx={{
              position: 'fixed',
              top: theme.header.height,
              left: theme.sidebar.width,
              right: 0,
              bottom: 0,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              backgroundColor: 'transparent',
              zIndex: theme.zIndex.drawer + 1,
              pointerEvents: 'none',
            }}
          >
            <CircularProgress color="primary" />
          </Box>
        )}
        <Box
          sx={{
            position: 'relative',
            zIndex: 5,
            display: 'block',
            flex: 1,
            backgroundColor: 'white',
            pt: `${theme.header.height}`,
            ml: `${theme.sidebar.width}`,
            overflowY: 'auto',
            height: `calc(100vh - ${theme.header.height})`,
          }}
        >
          <Box display="block">
            <AppAlerts />
            <Outlet />
          </Box>
        </Box>
      </FeatureAnnouncementProvider>
    </CommandPaletteProvider>
  )
}

export default SidebarLayout
